import { Component, Input, Output, EventEmitter } from '@angular/core';
import { openCloseAnimation, openCloseShadeAnimation } from './animations';
import { Router } from '@angular/router';

@Component({
    selector: 'app-ep-popup',
    templateUrl: './ep-popup.component.html',
    styleUrls: ['./ep-popup.component.scss'],
    animations: [
        openCloseAnimation,
        openCloseShadeAnimation,
    ],
    standalone: false
})
export class EpPopupComponent {
  @Input() modalTitle?: string;
  @Input() isOpen = false;
  @Input() isServiceError = false;
  @Output() closePopup = new EventEmitter();
  @Output() exportExcel = new EventEmitter();

  constructor(private router: Router) { }

  close = (e: any) => {
    e.preventDefault();
    if (this.closePopup) {
      this.closePopup.emit(e);
    }
  }

  printMembers() {
    window.print();
  }

  exportToExcel(event) {
    this.exportExcel.emit(event);
  }

  goToDashboard() {
    this.router.navigate(['/']);
    this.isOpen = false;
    this.isServiceError = false;
    this.closePopup.emit();
  }

}
